// src/components/chat/HamburgerButton.jsx
import React from 'react';
import { motion } from 'framer-motion';

const HamburgerButton = ({ isOpen, onClick }) => {
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      type="button"
      onClick={onClick}
      className={`p-2 bg-zinc-400/5 hover:bg-sky-500 text-white h-[50px] w-[50px] rounded-lg flex items-center justify-center transition-colors ${isOpen ? 'bg-sky-500' : ''}`}
      title="Bookmarks"
    >
      <div className="absolute top-3.5 right-6 w-6 h-6 ">
        <motion.span 
          className="absolute h-0.5 w-full bg-current rounded-full"
          initial={{ top: "6px", rotate: 0 }}
          animate={isOpen ? { top: "11px", rotate: 45 } : { top: "6px", rotate: 0 }}
          transition={{ duration: 0.2 }}
        />
        <motion.span 
          className="absolute top-[11px] h-0.5 w-full bg-current rounded-full"
          animate={isOpen ? { opacity: 0 } : { opacity: 1 }}
          transition={{ duration: 0.2 }}
        />
        <motion.span 
          className="absolute h-0.5 w-full bg-current rounded-full"
          initial={{ top: "16px", rotate: 0 }}
          animate={isOpen ? { top: "11px", rotate: -45 } : { top: "16px", rotate: 0 }}
          transition={{ duration: 0.2 }}
        />
      </div>
    </motion.button>
  );
};

export default HamburgerButton;